import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import QuasarConfig from 'RootDir/config/quasar_config';
import Plugins from 'RootDir/config/plugins';
import Middleware from 'RootDir/config/middleware';
import Sentrify from 'RootDir/config/sentry';

import vuexStore from 'RootDir/store/store';

import configRouter from 'RootDir/config/routers/index';
import 'RootDir/config/class-component-hooks';

import UserHelpers from 'RootDir/core/mixins/user_helper';
import Filters from 'RootDir/core/filters';

import App from './App.vue';

// Стили
import 'RootDir/assets/styles/app.scss';

Vue.use(Vuex);

Vue.use(VueRouter);

const router = configRouter(VueRouter);

const store = new Vuex.Store(vuexStore);

QuasarConfig(Vue);

Vue.mixin(UserHelpers);

Plugins(Vue, store);

Middleware(router, store);

Filters(Vue);

const VueApp: Vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

Sentrify(VueApp);

export default VueApp;
